import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CoreTable from "../../coreComponents/Table/Table.tsx";
import { deleteDriver, getAllVehicles } from "../../services/DriverService.ts";

interface Vehicle {
  id: number;
  driverId: number;
  vehicle_no: string;
  vehicle_type: string;
}

const columns = [
  { id: "id", label: "ID" },
  { id: "driverId", label: "DriverId" },
  { id: "vehicle_no", label: "Vehicle No" },
  { id: "vehicle_type", label: "Vehicle Type" },
];

const Vehicle: React.FC = () => {
  const navigate = useNavigate();
  const [vehicle, setVehicle] = useState<Vehicle[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchVehicle = async () => {
      try {
        const response = await getAllVehicles();
        if (response.data) {
          console.log(response.data);
          setVehicle(response.data);
        }
      } catch (err: any) {
        if (err.response && err.response.status === 401) {
          console.error("Unauthorized access. Redirecting to login...");
          navigate("/login");
        } else {
          setError("Failed to fetch drivers");
          console.log(err);
        }
      }
      finally {
        setLoading(false);
      }
    };

    fetchVehicle();
  }, []);


  const handleUpdate = (id: number) => {
    console.log(`Update driver with ID: ${id}`);
  };

  const handleDelete = async (id: number) => {
    const response = await deleteDriver(id);
    console.log(response.data);

    if (response.data) {
      const updatedDriverData = vehicle.filter((driver) => driver.id !== id);
      setVehicle(updatedDriverData);
    }
  };

  if (loading && vehicle.length === 0) return <div>Loading vehicles...</div>;

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
      </div>
      <CoreTable
        columns={columns}
        data={vehicle}
        // onUpdate={handleUpdate}
        // onDelete={handleDelete}
      />
    </div>
  );
};

export default Vehicle;
